var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.167,
    d: "M7 8.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.167,
    d: "M11.317 8.75a.963.963 0 0 0 .192 1.062l.035.035a1.166 1.166 0 1 1-1.65 1.65l-.036-.034a.962.962 0 0 0-1.061-.193.963.963 0 0 0-.584.88v.1a1.167 1.167 0 0 1-2.333 0v-.053a.962.962 0 0 0-.63-.88.962.962 0 0 0-1.062.192l-.035.035a1.166 1.166 0 0 1-1.993-.825 1.166 1.166 0 0 1 .343-.826l.035-.035a.962.962 0 0 0 .192-1.061.962.962 0 0 0-.88-.584h-.1a1.167 1.167 0 1 1 0-2.333h.053a.963.963 0 0 0 .88-.63.963.963 0 0 0-.192-1.062l-.035-.035a1.167 1.167 0 1 1 1.65-1.65l.036.035a.962.962 0 0 0 1.061.192h.047a.962.962 0 0 0 .583-.88v-.1a1.167 1.167 0 0 1 2.334 0v.053a.963.963 0 0 0 .583.88.963.963 0 0 0 1.062-.192l.035-.035a1.166 1.166 0 1 1 1.65 1.65l-.034.036a.963.963 0 0 0-.193 1.061v.047a.963.963 0 0 0 .88.583h.1a1.167 1.167 0 1 1 0 2.334h-.053a.963.963 0 0 0-.88.583Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/Icon_settings.64dddf116e8b0edff32bee8fc3ac0269.svg";
export { ForwardRef as ReactComponent };